import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, AuthService, MessageService } from '../../../core';
import { ClienteGrupoEconomicoFilter } from '../filter';
import { ClienteGrupoEconomicoSearchOrderBy } from '../cliente-grupo-economico-search-orderby';
import { ClienteGrupoEconomicoCrudHttpService } from '../services';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-cliente-grupo-economico-multiselect',
    templateUrl: './cliente-grupo-economico-multiselect.component.html',
    styleUrls: ['./cliente-grupo-economico-multiselect.component.less']
})
export class ClienteGrupoEconomicoMultiselectComponent implements OnInit {
    isRepresentante: boolean;

    /** Grupos econômicos de clientes selecionados */
    @Input() idsClientesGruposEconomicos: number[];
    /** Ao alterar a seleção dos grupos econômicos de clientes */
    @Output() idsClientesGruposEconomicosChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Grupo Econômico';
    @Input() checked = 'Grupo Econômico';
    @Input() checkedPlural = 'Grupos Econômicos';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum grupo econômico encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private authService: AuthService,
                private messageService: MessageService,
                private clienteGrupoEconomicoCrudHttpService: ClienteGrupoEconomicoCrudHttpService) { }

    ngOnInit() {
        this.isRepresentante = this.authService.isRepresentante();

        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-cliente-grupo-economico ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os grupos econômicos de clientes para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        const filter = new ClienteGrupoEconomicoFilter();
        // Representante
        if (this.isRepresentante) { // Representante logado
            filter.idsRepresentantes = [this.authService.getIdRepresentante()];
        }
        this.clienteGrupoEconomicoCrudHttpService.searchWithFilter(filter, ClienteGrupoEconomicoSearchOrderBy.Nome, 'asc', null, null)
            .pipe(
                take(1)
            )
            .subscribe(
                search => {
                    // Adicionando os grupos econômicos de clientes ao multiselect
                    if (search?.entities) {
                        search.entities.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: entity.nome
                            });
                        });
                        this.options = selects;
                    }
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar os grupos econômicos de clientes', error);
                }
            );
    }

    /** Ao alterar a seleção dos grupos econômicos de clientes */
    onChange() {
        this.idsClientesGruposEconomicosChange.emit(this.idsClientesGruposEconomicos);
    }
}
